import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FinanceDropdownComponent } from './finance-dropdown.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderModule } from 'ngx-order-pipe';
import { EnterPressDirective } from '../directives/enter-press.directive';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OrderModule,
    EnterPressDirective,
    TranslateModule,
  ],
  exports: [FinanceDropdownComponent],
  declarations: [FinanceDropdownComponent],
})
export class FinanceDropdownModule {}
